import { Outlet } from 'react-router-dom';
// material
import { styled } from '@material-ui/core';

// ----------------------------------------------------------------------

const RootStyle = styled('div')({
  minHeight: '100%',
});

// ----------------------------------------------------------------------

export default function BlankDashboardLayout() {
  return (
    <RootStyle>
      <Outlet />
    </RootStyle>
  );
}
